const AsignacionModulos = () => {
    const roles = [
        { id: 1, nombre: "Administrador" },
        { id: 2, nombre: "Instructor" },
        { id: 3, nombre: "Coordinador" },
        { id: 4, nombre: "Supervisor" },
        { id: 5, nombre: "Aprendiz" },
    ];

    const modulos = [
        { id: "aprendiz", nombre: "Aprendiz" },
        { id: "instructor", nombre: "Instructor" },
        { id: "contrato", nombre: "Contrato" },
        { id: "informe", nombre: "Informe Contractual" },
        { id: "agendas", nombre: "Agendas de Viaje" },
        { id: "institucional", nombre: "Institucional" },
        { id: "regionales", nombre: "Institucional - Regionales" },
        { id: "centros", nombre: "Centros de Formación" },
        { id: "programas", nombre: "Programas de Formación" },
        { id: "guias", nombre: "Guías de Aprendizaje" },
        { id: "grupos", nombre: "Grupos" },
        { id: "actas", nombre: "Actas" },
        { id: "enteconformador", nombre: "Ente Conformador" },
        { id: "matricula", nombre: "Matrícula" },
        { id: "asistencia", nombre: "Asistencia" },
    ];

    const accionesCRUD = ["Crear", "Leer", "Actualizar", "Eliminar"];

    return (
        <div className="container py-4">
            <h2 className="mb-4 text-center fw-bold text-primary">
                Asignación de Módulos y Permisos a Roles
            </h2>
            <div className="row">
                {/* Lista de Roles */}
                <div className="col-md-4">
                    <div className="card shadow-sm border-0">
                        <div className="card-header bg-primary text-white fw-semibold">
                            Roles
                        </div>
                        <ul className="list-group list-group-flush">
                            {roles.map((rol) => (
                                <li
                                    key={rol.id}
                                    className="list-group-item list-group-item-action"
                                    style={{ cursor: "pointer" }}
                                >
                                    {rol.nombre}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Lista de módulos */}
                <div className="col-md-8">
                    <div className="card shadow-sm border-0">
                        <div className="card-header bg-secondary text-white fw-semibold">
                            Módulos y Permisos
                        </div>
                        <div className="card-body">
                            <form>
                                {modulos.map((mod) => (
                                    <div
                                        key={mod.id}
                                        className="d-flex align-items-center justify-content-between py-2 px-3 mb-2 border-bottom"
                                        style={{ background: "#f8f9fa", borderRadius: "6px" }}
                                    >
                                        {/* Nombre módulo */}
                                        <div className="fw-semibold col-4">
                                            {mod.nombre}
                                        </div>

                                        {/* Opciones CRUD */}
                                        <div className="d-flex gap-3 col-8 justify-content-end">
                                            {accionesCRUD.map((accion) => (
                                                <div className="form-check form-check-inline" key={`${mod.id}-${accion}`}>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`${mod.id}-${accion}`}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor={`${mod.id}-${accion}`}
                                                    >
                                                        {accion}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}

                                {/* Botones */}
                                <div className="mt-4 text-end">
                                    <button type="button" className="btn btn-success px-4">
                                        Guardar Asignación
                                    </button>
                                    <button type="reset" className="btn btn-outline-secondary ms-2 px-4">
                                        Limpiar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AsignacionModulos;
